import { render, staticRenderFns } from "./PatientAppointmentView.vue?vue&type=template&id=1807d1a8&scoped=true&lang=pug"
import script from "./PatientAppointmentView.vue?vue&type=script&lang=js"
export * from "./PatientAppointmentView.vue?vue&type=script&lang=js"
import style0 from "./PatientAppointmentView.vue?vue&type=style&index=0&id=1807d1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807d1a8",
  null
  
)

export default component.exports